import React, { useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Ptext from 'components/common/Ptext';
import { FormattedMessage } from 'react-intl';
import LangSwitcher from 'LangSwitcher';
import { LocaleContext } from 'routes/Router';
import 'assets/styles/auth.scss';
import 'assets/styles/common.scss';

const AuthLayout = ({
  heroImage,
  logo,
  quote,
  author,
  children,
  zoomHero = false,
}) => {
  const { locale } = useContext(LocaleContext);

  return (
    <Container fluid className="h-screen overflow-hidden bg-[#FAFAF9]">
      <LangSwitcher />
      <Row className="h-full m-0 ">
        {/* Left Side */}
        <Col
          lg={7}
          xl={7}
          className="hidden lg:flex items-center justify-center p-3"
        >
          <div className="relative w-full h-[calc(100vh-40px)] overflow-hidden rounded-[32px]">
            <img
              src={heroImage}
              alt="hero"
              className={`w-full h-full object-cover ${
                zoomHero ? 'object-[80%_center]' : ''
              }`}
            />

            <div
              className="
                absolute inset-0 z-[2]
                flex flex-col justify-between
                p-8 xl:p-10
                bg-gradient-to-t
                from-black/45
                to-black/5
              "
            >
              {logo && (
                <img
                  src={logo}
                  alt="logo"
                  className="w-[180px] xl:w-[212px] h-auto object-contain"
                />
              )}

              <div className="max-w-[500px] xl:max-w-[560px] 2xl:max-w-[680px]">
                <Ptext
                  variant="body"
                  className="
                    text-[#FAFAF9]
                    text-[20px]
                    xl:text-[22px]
                    2xl:text-[24px]
                    leading-[28px]
                    xl:leading-[30px]
                    2xl:leading-[32px]
                    font-normal
                    mb-5
                  "
                >
                  <FormattedMessage id={quote} />
                </Ptext>

                <Ptext
                  variant="body"
                  className="
                    text-[#FAFAF9]
                    text-[20px]
                    xl:text-[22px]
                    2xl:text-[24px]
                    leading-[28px]
                    xl:leading-[30px]
                    2xl:leading-[32px]
                    font-medium
                    mb-0
                  "
                >
                  {author}
                </Ptext>
              </div>
            </div>
          </div>
        </Col>

        {/* Right Side */}
        <Col
          xs={12}
          lg={5}
          className="
            h-full
            flex items-center justify-center
            bg-[#FAFAF9]
            px-[18px]
            py-6
            sm:px-5
            lg:px-6 lg:py-10
          "
        >
          <div className="w-full max-w-[460px]">{children}</div>
        </Col>
      </Row>
    </Container>
  );
};

export default AuthLayout;
